import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

// Iter 54 — Nav rebuilt for the web-first product. The legacy nav
// pointed at `/dashboard`, `/memory`, `/report-card`, `/history`,
// `/progress`, `/reflect` — all pre-WhatsApp pages we've now retired.
// Keep the surface tiny: brand → /chat, Plus, account/sign-out.
export default function Nav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  const isPlus = location.pathname === "/plus" || location.pathname.startsWith("/plus/");

  return (
    <nav
      data-testid="primary-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#0A0A0A]/80 border-b"
      style={{
        borderColor: "var(--border-default)",
        // Iter XX.267a — respect the iOS status-bar / Dynamic Island
        // safe-area so Chat / Plus / Sign-in stop colliding with the
        // notch on physical iPhones.
        paddingTop: "env(safe-area-inset-top, 0px)",
      }}
    >
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/chat" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="font-display text-2xl tracking-tight">gully</span>
          <span className="label-eyebrow ml-1">cricket coach</span>
        </Link>

        <div className="flex items-center gap-1">
          <Link
            to="/chat"
            data-testid="nav-chat"
            className={`px-3 py-2 text-sm font-display transition-colors ${
              location.pathname === "/chat" ? "text-[#A7F3D0]" : "text-neutral-300 hover:text-white"
            }`}
          >
            Chat
          </Link>
          <Link
            to="/plus"
            data-testid="nav-upgrade"
            className="ml-2 px-3 py-2 text-xs font-display rounded border transition-colors inline-flex items-center gap-1"
            style={{
              borderColor: "var(--highlight)",
              color: isPlus ? "#0A0A0A" : "var(--highlight)",
              backgroundColor: isPlus ? "var(--highlight)" : "transparent",
            }}
          >
            {!isPlus && <span aria-hidden="true">⭐</span>}
            Plus
          </Link>
          {user ? (
            <button
              data-testid="nav-logout"
              onClick={onLogout}
              className="ml-2 text-xs text-neutral-500 hover:text-neutral-300 transition-colors"
            >
              Sign out
            </button>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login"
              className="ml-2 text-xs text-neutral-500 hover:text-neutral-300 transition-colors"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
